import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { UseAuthContext } from '../../context/AuthContext';
import {  getErrorMsg } from '../utils/commonUtil';

export default function SearchByRadius({ setResultData, setSearchSubmit }) {
    const { t } = useTranslation();
    const { token } = UseAuthContext();
    const [load, setLoad] = useState(false);
    const [isValid, setIsValid] = useState(true);
    const [searchParams, setSearchParams] = useState({
       radius: "5", //5
       searchType: "xy-co-ordinate"
    });
    const [addressIdValue, setAddressIdValue] = useState("")

    const [pageInfo, setPageInfo] = useState({
        page: 0,
        size: "5"
    });

    const handleInput = (e) => {
        let id = e.target.id;
        let value = e.target.value;
        setSearchParams(pre => ({ ...pre, [id]: value }));
        setIsValid(true);
        setAddressIdValue("");
        setResultData({ data: null, loading: false, msg: "" });
    }
    const handleAddressInput = (e) => {
       setAddressIdValue(e.target.value);
       setIsValid(true);
    }

    const resetAll = () => {
        setSearchParams({
            radius: "5", //5           
            searchType: "xy-co-ordinate"
        });
        setPageInfo({
            page: 0,
            size: "5"
        })
        setResultData({ data: null, loading: false, msg: "" });
        setIsValid(true);
        setAddressIdValue("");
    }

    const getErrorLabel = () => {
        const label = searchParams.searchType === 'xy-co-ordinate' ? 'Please enter valid cooridnates. Example: 1232.122, 3453.544'
                     : t(`search.${searchParams.searchType}`);
        const enterMsg = searchParams.searchType === 'xy-co-ordinate' ? '' : t('search.please_enter');
        return `${enterMsg} ${label}`;
    }

    const transformAddressData = (data) => {
        return {
            content: data.content?.map((item) => ({
            id: item.specificId,
            accessAddress: {
                id: item.addressId,
                darId: item.darId,
                kvhxId: item.kvhxid,
                streetId: {
                    id: null,
                    code: item.addressStreetCode,
                    name: item.addressStreetName,
                    streetNameAddr: item.addressStreetName,
                    isDeleted: item.addressDeleted ? "Y" : "N",
                    oldStreetId: null,
                    municipality: {
                        municipalityCode: item.addressMunicipalityCode,
                        municipalityName: item.addressMunicipality,
                        region: {
                          id: null,
                          name: item.addressRegionName
                        },
                        isDeleted: item.addressDeleted ? "Y" : "N"
                    }
                },
                streetBuildingId: item.addressBuildingNo,
                postCodeId: {
                    id: item.addressPostcode,
                    districtName: item.addressDistrict,
                    isDeleted: item.addressDeleted ? "Y" : "N"
                },
                madId: item.madId,
                isOfficial: item.isOfficial,
                isDeleted: item.addressDeleted ? "Y" : "N",
                geocode: `${item.x_coordinate},${item.y_coordinate}`
            },
            darId: item.darId,
            kvhxId: item.kvhxid,
            madId: item.specificMadId,
            floorId: item.floorNo,
            suiteId: item.suiteNo,
            isOfficial: item.isOfficial,
            isDeleted: item.addressDeleted ? "Y" : "N",
            created: null,
            modified: null
            }))
        };
    };

    const searchHandler = (pageNo) => {
        if ((searchParams.searchType === "xy-co-ordinate" ) && !(/^\s*-?\d+(\.\d+)?\s*,\s*-?\d+(\.\d+)?\s*$/).test(addressIdValue)) {
            setIsValid(false);
        } 
        else if((searchParams.searchType === "access-mad-id" ||
            searchParams.searchType === "access-dar-id" ||
            searchParams.searchType === "specific-dar-id" ||
            searchParams.searchType === "specific-mad-id") && !(/^[A-F0-9]{32}$/i).test(addressIdValue)) {
            setIsValid(false);
        }
        else if((searchParams.searchType === "access-id" || searchParams.searchType === "specific-id")
            && !(/^[0-9]+$/).test(addressIdValue)) {
            setIsValid(false);
        } else {
            setLoad(true);
            setIsValid(true);
            setResultData({ data: null, loading: true, msg: t('result.loading') });
            const queryParams = `page=${pageNo}&perPage=${pageInfo.size}&searchType=${searchParams.searchType}&searchId=${addressIdValue.replace(/\s/g, '')}&radius=${searchParams.radius}`
            axios.get(`/api/v1/address/searchByRadius?${queryParams}`, { headers: { "Authorization": `Bearer ${token}` } })
                .then(res => {
                    if (res.data?.content.length === 0) {
                        setResultData({ data: null, loading: false, msg: t('result.no_data') });
                    } else if (res.data?.content && res.data?.content?.length > 0) {
                        let origObje = res.data;
                        const test = transformAddressData(res.data);
                        origObje.content = test.content;
                        setResultData({ data: origObje, loading: false, msg: "" });
                    } else {
                        const transformedData = transformAddressData(res.data);
                        setResultData({ data: transformedData, loading: false, msg: "" });
                    }
                    setLoad(false);
                })
                .catch(err => {
                    setResultData({ data: null, loading: false, msg: getErrorMsg(err.message) });
                    setLoad(false);
                })
        }
        
    }

    return (
        <div className="mt-2 text-sm">
            <div className="form-row" style={{marginTop:"15px"}}>                
                <div className="form-group col-md">
                    <label htmlFor="radius">{t('search.radius')}</label>
                    <select id="radius" className="form-control form-control-sm"
                        value={searchParams.radius} onChange={handleInput}>
                        <option value="5" >5</option>
                        <option value="10" >10</option>
                        <option value="15" >15</option>
                        <option value="20" >20</option>
                        <option value="25" >25</option>
                        <option value="50" >50</option>
                    </select>
                </div>
                <div className="form-group col-md">
                    <label htmlFor="searchType">{t('search.address_identifier')}</label>
                    <select id="searchType" className="form-control form-control-sm"
                        value={searchParams.searchType} onChange={handleInput}>
                        <option value="xy-co-ordinate" >{t('search.xy-co-ordinate')}</option>
                        <option value="access-id">{t('search.access-id')}</option>
                        <option value="access-mad-id">{t('search.access-mad-id')}</option>
                        <option value="access-dar-id">{t('search.access-dar-id')}</option>
                        <option value="specific-id">{t('search.specific-id')}</option>
                        <option value="specific-mad-id">{t('search.specific-mad-id')}</option>
                        <option value="specific-dar-id">{t('search.specific-dar-id')}</option>

                    </select>
                </div>
                <div className="form-group col-md">
                    <label htmlFor="addressId">{t('search.enter_address_identifier')}</label><span>*</span>
                    <input type="text" className={`form-control form-control-sm ${!isValid ? 'input-error' : ''}`} id="addressId"
                        value={addressIdValue} onChange={handleAddressInput} 
                        placeholder={searchParams.searchType !== "xy-co-ordinate" ? '' : 'Example: 1232.122, 3453.544'}/>
                    {!isValid &&<span className='input-error'>{getErrorLabel()}</span>}
                </div>
                <div className="form-group col-md">
                    <label htmlFor="size">{t('search.records')}</label>
                    <select id="size" className="form-control form-control-sm"
                        value={pageInfo.size} onChange={(e) => setPageInfo(pre => ({ page: 0, size: e.target.value }))}>
                        <option value="5" >5</option>
                        <option value="10" >10</option>
                        <option value="15" >15</option>
                        <option value="20" >20</option>
                        <option value="25" >25</option>
                        <option value="50" >50</option>
                    </select>
                </div>
            </div>
            
            <div className="row gy-1">
                <div className="col-6 text-right">
                    <button className="btn btn-primary"
                        disabled={load || addressIdValue === ''}
                        onClick={() => { searchHandler(0); setSearchSubmit(() => searchHandler) }}>{load ? t('search.wait') : t('search.search')}</button>
                </div>
                <div className="col-6 text-left">
                    <button className="btn btn-secondary ml-1" onClick={() => resetAll()}>{t('search.reset')}</button>
                </div>
            </div>

        </div>
    )
}
